import { Parallax } from 'react-parallax';
import HeroImg from '../assets/main_hero.jpg'
import { useEffect, useState } from "react";
import { fetchPageContent } from "../api/contentApi";
import { useLang } from "../context/LangContext";
import "../styles/main_hero.css";


const HeroSection = () => {
  const [content, setContent] = useState({});
  const { lang } = useLang();

  useEffect(() => {
    fetchPageContent("main", lang).then(data => setContent(data));
  }, [lang]);
  
  return (
    <Parallax 
    blur={1.5} 
    bgImage={HeroImg} 
    bgImageAlt="hero img" 
    strength={600}
    className="hero-img"
    >
    
    <span className="hero-content" >
      {content.company_name && ( 
   <p className="hero-text">{content.company_name}</p>)}
    {/* {content.main_title && ( 
   <p className="hero-subtext">{content.main_title}</p>)} */}
     {content.main_subtitle && ( 
   <p className="hero-subtext">{content.main_subtitle}</p>)}


    </span>
    </Parallax>
  );
}
export default HeroSection;